// Friends & Family groups — thin API wrappers. Anonymous, device-based, same
// identity as the rest of SpotDrop (X-Device-Id is injected by lib/api.js).

import { api } from "./api";

export async function createGroup(name, nickname) {
  const res = await api.post("/groups", { name, nickname: nickname || null });
  return res.data;
}

export async function fetchMyGroups() {
  const res = await api.get("/groups/mine");
  return res.data;
}

export async function fetchGroup(groupId) {
  const res = await api.get(`/groups/${groupId}`);
  return res.data;
}

export async function previewGroup(code) {
  const res = await api.get(`/groups/preview/${code}`);
  return res.data;
}

export async function joinGroup(code, nickname) {
  const res = await api.post("/groups/join", { code, nickname: nickname || null });
  return res.data;
}

export async function updateSharing(groupId, payload) {
  const res = await api.put(`/groups/${groupId}/sharing`, payload);
  return res.data;
}

/** Foreground heartbeat. Silent on failure — must never block the map. */
export function sendLiveBeat(lat, lng) {
  api.post("/groups/live", { lat, lng }).catch(() => {});
}

export async function fetchGroupOverlay() {
  try {
    const res = await api.get("/groups/overlay");
    return res.data;
  } catch {
    return null;
  }
}

export function buildGroupInviteUrl(code) {
  const clean = String(code || "").trim().toUpperCase();
  if (!clean) return "";
  if (typeof window === "undefined") return `/g/${clean}`;
  return `${window.location.origin}/g/${clean}`;
}

/** Native share → WhatsApp → clipboard, same cascade as the referral share. */
export async function shareGroupInvite(code, groupName, notify) {
  const say = typeof notify === "function" ? notify : () => {};
  const link = buildGroupInviteUrl(code);
  if (!link) {
    say("error", "Could not build the invite link.");
    return "none";
  }
  const text = `Join my private SpotDrop group "${groupName}" to share parking and location with people you trust.`;

  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({ title: "SpotDrop — private group", text, url: link });
      return "native";
    } catch (err) {
      if (err && (err.name === "AbortError" || err.code === 20)) return "native";
    }
  }
  if (typeof window !== "undefined") {
    try {
      const w = window.open(
        `https://wa.me/?text=${encodeURIComponent(`${text}\n${link}`)}`,
        "_blank",
        "noopener,noreferrer"
      );
      if (w) return "whatsapp";
    } catch {
      /* ignore */
    }
  }
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(link);
      say("success", "Invite link copied");
      return "copy";
    } catch {
      /* ignore */
    }
  }
  say("error", "Could not open the share sheet. Please try again.");
  return "none";
}
